/**
 * Transform frame data to normalized structure
 * Backend sends flat structure for inventory items
 */
export const transformCatalogFrameToFrameData = (selectedFrame) => {
    // Backend already normalized - return as-is if it has the expected flat structure
    if (selectedFrame.properties && selectedFrame.itemId !== undefined) {
        return {
            id: selectedFrame.id,
            itemId: selectedFrame.itemId,
            modelNumber: selectedFrame.modelNumber || '',
            brand: selectedFrame.brand || { name: '' },
            supplier: selectedFrame.supplier || { supplierName: '' },
            properties: selectedFrame.properties,
            listPrice: selectedFrame.listPrice || 0.0,
            isTaxable: selectedFrame.isTaxable || false,
            defaultTaxPercentage: selectedFrame.defaultTaxPercentage || 0,
            location: selectedFrame.location || { name: '' }
        };
    }

    // Fallback for legacy structure (shouldn't happen with new backend)
    console.warn('Received legacy frame structure, consider updating backend normalization');
    return {
        id: selectedFrame.id,
        itemId: selectedFrame.id,
        modelNumber: selectedFrame.modelNumber || '',
        brand: { name: '' },
        supplier: { supplierName: '' },
        properties: {},
        listPrice: selectedFrame.listPrice || 0.0,
        isTaxable: false,
        defaultTaxPercentage: 0,
        location: { name: '' }
    };
};

/**
 * Check if frame data is from catalog
 */
export const isCatalogFrame = (frameData) => {
    return frameData && frameData.catalogProduct !== undefined;
};
